import React from "react";
import Hero from "../components/Hero";
import PromoStrip from "../components/PromoStrip";
import Customizer from "../components/Customizer";
import ProductGrid from "../components/ProductGrid";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  return (
    <>
      <Hero />
      <PromoStrip />
      <Customizer onAdded={() => {}} />
      <ProductGrid
        title="Productos destacados"
        subtitle="Fundas personalizadas, diseños y accesorios para tu celular."
        onCustomize={(p) => {
          navigate("/personalizar", { state: { product: p } });
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      />
    </>
  );
}
